// @givmo/app-charity — removal-request validation (Zod) (CPA-WEB7).
//
// Client-side shape validation for the single removal-request field. The backend (`SubmitRemovalRequest`)
// requires a NON-EMPTY `written_request_reason` — the safe-harbor "support for written requests" note; it
// is recorded on the request + the audit event. The backend is authoritative and re-validates; this schema
// only gates the confirm/submit control and gives inline feedback.

import { z } from 'zod';

export const REASON_MAX = 2000;
export const REASON_MESSAGE = 'Please tell us briefly why you’re requesting removal.';

/** The removal-request form values (mirrors `SubmitRemovalRequest`). */
export const removalRequestSchema = z.object({
  written_request_reason: z.string().trim().min(1, { message: REASON_MESSAGE }).max(REASON_MAX),
});
export type RemovalRequestFormValues = z.infer<typeof removalRequestSchema>;

export const EMPTY_REMOVAL_FORM: RemovalRequestFormValues = { written_request_reason: '' };
